import { db } from "../firebase/config";
import getTime from "./getTime";

const addComment = (
  userID: string,
  message: string,
  collection: string,
  collectionID: string
) => {
  if (message === "") {
    return;
  }

  db.collection("comments")
    .doc()
    .set(
      {
        user: db.collection("profiles").doc(userID),
        message,
        collection,
        collectionID,
        time: getTime(),
      },
      { merge: true }
    );
};

export default addComment;
